import * as React from 'react'

import { useEffect, useState, useRef } from 'react';

import {
  api,
  getCiaFromUrl,
  PortalContext,
  PortalSplash
} from '@portal/arq-portal-core';
import ReactWebChat, { createDirectLine, createStore } from 'botframework-webchat';
import { makeStyles,
  //  IconButton 
  } from '@material-ui/core';
import simpleUpdateIn from 'simple-update-in';
import { findQueryKeyNoCaseSensitive } from './helpers';

export interface RequestBody {
  NombreUsuario: string,
  IdUsuario: string,
  Dominio: string,
  IdBot: string
}

const useStyles = makeStyles((theme) => ({
  webChatExtended:{
    display: 'flex',
    alignItems:'flex-end',
    height: 'calc(100vh - 70px)',
    margin: '5px',
    

    '& .webchat__bubble__content': {
      maxWidth: 'fit-content !important',
      wordBreak: 'break-word',
      borderColor: '#505050 !important',  
      color: '#505050 !important',
      fontFamily: "Catalana-sans, Arial, sans-serif !important",
    },
    '& .webchat__bubble': {
      display: 'flex',
      justifyContent: 'flex-start',
      width: '100%'
    },

    '& .webchat__send-box__main':{
      border: '1px solid  #505050 !important', 
      color: '#505050 !important'
    },  

    '& .webchat__stacked-layout__message': {
      maxWidth: 'fit-content !important',
    },
    '& .webchat__bubble--from-user':{
      maxWidth: 'fit-content !important',
    },
    '& .webchat__typingIndicator':{ 
      backgroundImage: 'url("/assets/chatbot_loading.gif")',
      backgroundSize: 'contain',
      height: '40px !important' ,
    },

    '& .webchat__icon-button svg':{
      fill: '#505050 !important'
    },
    '& .webchat__icon-button:hover svg ':{
      fill: '#50505080 !important'
    }
  },
  webchat: {
    display: "flex",
    flexDirection:"column",
    bottom: "150px",
    position: "fixed",
    maxHeight: "500px",
    minHeight: "200px",
    minWidth: "250px",
    maxWidth:"400px",
    height: "60%",
    width: "400px",
    zIndex: 99,
    border: "1px solid #c8c8c8",
    boxShadow: "0px 4px 11px rgb(0 0 0 / 20%)",
    [theme.breakpoints.down('sm')]: {
      bottom: "100px",
      width: '90%',
      height: "45%",
      maxWidth: "300px"
    },
    [theme.breakpoints.down('xs')]:{
      bottom: "95px",
      width: '90%',
      height: "45%",
      maxWidth: "300px",
    }
  },
  wchatRight: {
    right: "40px",
    [theme.breakpoints.down('sm')]: {
      right: "30px",
    },
    [theme.breakpoints.down('xs')]:{
      right: "20px",
    }
  },
  wchatLeft: {
    left: "40px",
    [theme.breakpoints.down('sm')]: {
      left: "30px",
    },
    [theme.breakpoints.down('xs')]:{
      left: "20px",
    }
  },

  webchatHeader:{
    display:'flex',
    justifyContent:'space-between',
    flexShrink: 0,
    backgroundColor: '#e2e2e2'
  },
  wchatHeaderRight:{
    flexDirection:'row'
  },
  wchatHeaderLeft:{
    flexDirection:'row-reverse'
  },


  headerButton: {
    border: '0px',
    fontSize: '16px',
    height: 'fit-content',
    width: 'fit-content',
    padding: '0px 0px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  chatbotButton: {
    position: "fixed",
    bottom: "60px",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    backgroundColor: "rgb(220, 0, 40) !important",
    color: "white !important",
    fontFamily: "Catalana-sans, Arial, sans-serif !important",
    border: "none !important",
    zIndex: 99,
    minWidth: "0",
    boxShadow: "1px 4px 15px rgb(0 0 0 / 30%)",
    [theme.breakpoints.down('sm')]: {
      bottom: "15px",
    },
    [theme.breakpoints.down('xs')]:{
      bottom: "10px",
    }
  },
  cButtonRight:{
    right:"40px",
    [theme.breakpoints.down('sm')]: {
      right:  "30px"
    },
    [theme.breakpoints.down('xs')]:{
      right:  "20px"
    }
  },
  cButtonLeft:{
    left:"40px",
    [theme.breakpoints.down('sm')]: {
      left:  "30px"
    },
    [theme.breakpoints.down('xs')]:{
      left:  "20px"
    }
  },
  webChatBody:{
    flexGrow: 1,
    overflow: 'hidden',
    '& .webchat__typingIndicator':{ 
      backgroundImage: 'url("/assets/chatbot_loading.svg")',
      backgroundSize: 'contain',
      height: '30px !important' ,
    },
    '& .webchat__icon-button svg':{
      fill: '#505050 !important'
    },
    '& .webchat__icon-button:hover svg ':{
      fill: '#50505080 !important'
    },
    '& .webchat__send-box__main':{
      color: '#505050 !important'
    }
  },
  iconChat: {
    fontSize: '37px',
    color: '#fff !important',
  }
  
}));


export const Chatbot = (props: any) => {
  const classes = useStyles(props);
  const { user } = React.useContext(PortalContext);
  const [token,setToken] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const botAvatarImage = '/assets/chatbot-icon.png';
  const [hide, setHide] = React.useState(props?.hide ?? true)
  let isFullScreen = props?.isFullScreen? props?.isFullScreen?.toUpperCase() == "TRUE" : false;
  let idBot: string = props?.idBot ? props?.idBot?.toUpperCase() : "IT" // IT or Agente
  const [initialize, setInitialize] = React.useState(true);
  var convenioParam = findQueryKeyNoCaseSensitive('convenio'); 
  let cnv = !convenioParam && props && props.convenio? props.convenio : convenioParam; 
  if (idBot == 'RRHH' && !cnv){
      cnv = 'C_GCO';
  }
  const [convenio] = React.useState<string|null>(cnv);
  const  [callRemote,setCallRemote] = React.useState(false);
  const fetchedTokenRef = useRef<string | null>(null);
  const fetchedHideRef = useRef<boolean | null>(null);
  const [isFetching, setIsFetching] = useState(false);
  const  [callRemotePos,setCallRemotePos] = React.useState(false);
  const fetchedPosRef = useRef<boolean | null>(null);
  const [isFetchingPos, setIsFetchingPos] = useState(false);

  const [isLeftPosition, setIsLeftPosition] = React.useState(false);
  // const [isRightPosition] = React.useState(true);
  let pathFullScreen = `/Aplicacion?Aplicacion=AplicacionesReact&urlTransaccion=bot;idBot:${idBot};isFullScreen:True`;
  React.useEffect(() => {
    // Call this effect only once on component mount to initialize
    if (initialize) {
      setInitialize(false);
      initializeFunc(user);
    }
  }, [initialize]);

  React.useEffect(()=>{
    if(callRemote){
      setCallRemote(false)
      setIsFetching(true);
      const sessionvarherr = GenerarVariableSesionToken(user);
        const service = "/be/obtenerchatbottoken/";
        let requestBody: { Entrada: RequestBody } = {
          Entrada: {
            NombreUsuario: user?.user??"",
            IdUsuario: user?.id??"",
            Dominio: window.location.protocol.toLowerCase() + '//' + window.location.hostname.toLowerCase(),
            IdBot: idBot
          }
        };

        api.post(service, requestBody).then(data => {
          if (data?.Salida?.Hide != null && hide !== data.Salida.Hide) {
            fetchedHideRef.current = data.Salida.Hide;
          }
          if (data?.Salida?.Token) {
              sessionStorage.setItem(sessionvarherr, data.Salida.Token);
              sessionStorage.setItem(sessionvarherr + "TIME", Date.now().toString());
              fetchedTokenRef.current = data.Salida.Token;
          }
          setIsFetching(false);
        });
    }
  },[callRemote])


  useEffect(() => {
    if (!isFetching) {
      if (fetchedTokenRef.current != null && fetchedTokenRef.current !== "") {
        setToken(fetchedTokenRef.current);
      }
      if (fetchedHideRef.current != null) {
        setHide(fetchedHideRef.current);
      }
    }
  }, [isFetching, setToken, setHide]);

  React.useEffect(()=>{
    if(callRemotePos){
      setCallRemotePos(false)
      setIsFetchingPos(true);
      const service = "/be/posicionchatbot/";
      let requestBody: { Entrada: any } = {
        Entrada: {}
      };
      api.post(service,requestBody).then(data => {
        if (data?.Salida?.IzqChatbot != null && isLeftPosition !== data.Salida.IzqChatbot) {
          fetchedPosRef.current = data.Salida.IzqChatbot;
        }
        setIsFetchingPos(false);
      });
    }
  },[callRemotePos])

  useEffect(() => {
    if (!isFetchingPos) {
      if (fetchedPosRef.current != null) {
        UpdatePosChatbot(fetchedPosRef.current);
      }
    }
  }, [isFetchingPos]);

  
  useEffect(() => {
     if (open){
       GetToken(user);
     }
  },[open])
  
  function initializeFunc(user: any) {
    GetToken(user);
    if(!isFullScreen){
       GetPosChatbot();
    }
  }

  function GetPosChatbot() {
    setCallRemotePos(true);
  }

  function UpdatePosChatbot(izqPosChatbot:boolean, updateRemote: boolean = false){
    if(updateRemote){
        const service = "/be/posicionchatbotguardar/";
        let requestBody: { Entrada: {IzqChatbot:boolean} } = {
          Entrada: {
            IzqChatbot : izqPosChatbot,
          }
        };
        UpdatePosChatbot(izqPosChatbot, false);
        api.post(service, requestBody);
        // api.post(service, requestBody).then(data => {
        //   if (data?.Salida?.IzqChatbot != null && isLeftPosition !== data.Salida.IzqChatbot) {
        //     UpdatePosChatbot(data.Salida.IzqChatbot, false);
        //   }
        // });
    }else{
      setIsLeftPosition(izqPosChatbot); 
      if(open){
        setOpen(false);
        setTimeout(() => {
            setOpen(true);
          }, 250); 
      }
    }
  }


  function GetToken(user:any){
    //DETECTAMOS SI EL USUARIO YA TIENE TOKEN
    let sessionvarherr = GenerarVariableSesionToken(user);
    let cacheToken: any = sessionStorage.getItem(sessionvarherr);
    let cacheTokenTime: string | null= sessionStorage.getItem(sessionvarherr + "TIME");
    console.log({cacheToken,cacheTokenTime})
    if (cacheToken != null && cacheToken != "" && cacheTokenTime != null && cacheTokenTime != "" && validateTime(cacheTokenTime)) {
      console.log('retrieve token from cache')
      if(token == null || (token != null && token != cacheToken)){
        setToken(cacheToken);
      }
      if(token != null && hide){
        setHide(false);
      }
    } else {
      console.log('retrieve token from server')
      setCallRemote(true);
    }
  }

  const directLine = React.useMemo(() => createDirectLine({ token: token, domain:"https://europe.directline.botframework.com/v3/directline" }), [token, open]);


  function GenerarVariableSesionToken(user: any) {
    let obj = {
      codUsuario: user.user,
      codEmpresa: getCiaFromUrl(),
      idBot: idBot,
      patron: "AZURECHATBOT_ACCESS_TOKEN"
    }
    return obj.codUsuario.replace("\\", "") + "_" + obj.codEmpresa + "_" + obj.patron + "_" + obj.idBot;
  }

  function validateTime(timestamp:string){
    if(timestamp != null && timestamp != "") {
      const  givenTimestamp =  parseInt(timestamp)
      const currentTime = Date.now();
      // 10 minutos son ( 1 minuto = 60s = 60000 mls) => 10 minutos = 600000 mls
      return (currentTime - givenTimestamp) <  600000
    }
    return false
  }

  const styleOptions = {
    // botAvatarImage: 'https://i.ibb.co/0M32Z5t/avatar-vero.png',
    botAvatarImage: botAvatarImage,
    botAvatarInitials: "ONA",
    userAvatarImage: api.getApiServer() + user?.foto,
    userAvatarInitials: user?.ini ?? 'USR',
    botAvatarBackgroundColor: "#dc0028",
    userAvatarBackgroundColor: "#dc0028",
    backgroundColor: "#f4f4f4",
    hideUploadButton: true,
    sendBoxButtonColorOnFocus: "#dc0028",
    sendBoxButtonColorOnHover: "#d6d8d8",
  };

  var device ={
    device : navigator.userAgent.replaceAll(';', '|')
  }
  const store = createStore({}, (_ref: any) => (next: any) => (action: any) => {
    if (action.type === "DIRECT_LINE/POST_ACTIVITY") {
      action = simpleUpdateIn(action, ['payload', 'activity', 'channelData', 'params'], () =>
      {
        return { 
          email: props.user?.mail,
          scoreThreshold: "0.5",
          ambiguityCoef: "0.95",
          ambiguityMaxDiff: "0.1",
          ambiguityNumOptions: "5"
        }
      });
    }

    if(device){
      action = simpleUpdateIn(action, ['payload', 'activity', 'channelData', 'customInfo'], ()=> device);
    }
    if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
      new Promise(function (resolve) {
        console.log({convenio})
        if(convenio){
           _ref.dispatch({
             type: "WEB_CHAT/SEND_EVENT",
             payload: {
               name: 'pvaSetContext',
               value: { "UsuarioContexto": "" + convenio + "" }
             }
           })
         }else{
           _ref.dispatch({
             type: "WEB_CHAT/SEND_EVENT",
             payload: {
               name: "webchat/join",
               value: "es-ES"
             }
           })
         }
        setTimeout(() => resolve(1), 1000);
      }).then(function () {
        _ref.dispatch({
          meta: {
            method: "keyboard"
          },
          payload: {
            activity: {
              channelData: {
                postBack: true
              },
              name: "startConversation",
              type: "event"
            },
          },
          type: "DIRECT_LINE/POST_ACTIVITY"
        });
      });
    }
    return next(action);
  });
  
  return hide ? 
          (isFullScreen)? 
            (callRemote || isFetching)?
            <PortalSplash titulo="Chatbot"></PortalSplash>
             :   
            <PortalSplash  mensaje={ {
              titulo: "No dispone de permisos para usar el chatbot '" + idBot?.toLocaleLowerCase()+ "'",
              subtitulo: "Si deberia acceder por favor pongase en contacto con soporte",
              tipo: "error"
            }}></PortalSplash>
          :
          null 
        :
      isFullScreen? <div className ={classes.webChatExtended}>
        {(user != null && token != null && token != "") && <ReactWebChat directLine={directLine} userID={user?.id} styleOptions={styleOptions} store={store} username={user?.user} />}
      </div> :
      <section id="sectionChatbotAzure" className="sectionChatbotAzure">
        <button
          className={classes.chatbotButton + " " +  (isLeftPosition?classes.cButtonLeft: classes.cButtonRight)}
          type="button"
          onClick={() => {
            setOpen(!open);
          }
          }
        >
          <i className={`icon-chat ${classes.iconChat}`}> </i>
        </button>
        { open && <React.Fragment> 
          <div id="chatbotContainer">
            <div className= {classes.webchat+ " " + (isLeftPosition?classes.wchatLeft:classes.wchatRight)} role="main">
              <div className={((isLeftPosition)?(classes.wchatHeaderLeft):(classes.wchatHeaderRight)) +  " "+ classes.webchatHeader}>
                  <div>
                  <button className={classes.headerButton} onClick={() => {UpdatePosChatbot(!isLeftPosition,true);}} type="button" title={isLeftPosition? "Mover a la derecha":"Mover a la izquierda"}>
                    <i className={ isLeftPosition? `icon-flecha`: `icon-gen-flecha-2` }> </i>
                  </button>
                  </div>
                  <div className={((isLeftPosition)?(classes.wchatHeaderLeft):(classes.wchatHeaderRight)) +  " "+ classes.webchatHeader}>
                    <a href={pathFullScreen} target="_blank" title ="Abrir en ventana externa">  
                      <button className={classes.headerButton} type="button">
                        <i className={`icon-enlace-ext`}> </i>
                      </button>
                    </a>
                    <button className={classes.headerButton} title="Minimizar" onClick={() => {setOpen(!open)}} type="button">
                      <i className={`icon-menos`}> </i>
                    </button>
                  </div>
              </div>
               <div className={classes.webChatBody} >
                {(user != null && token != null && token != "") && <ReactWebChat directLine={directLine} userID={user?.id} styleOptions={styleOptions} store={store} username={user?.user} />} 
               </div> 
            </div>
          </div>
        </React.Fragment>
        }
      </section>
}